// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "மோத்த வெகுமதிப் புள்ளிகள்",
          pointsSectionSubtitle: "புதிய லெவெல் சென்று வெகுமதிகளைப் பெறுங்கள்",
          dailyRewardsHeader: "தினசரி வெகுமதிகள்",
          cardCtaText: "வெகுமதிகளை பெற இங்கே தட்டவும்",
          allRewardsClaimedTitle: "வாழ்த்துக்கள்",
          allRewardsClaimedText: "நீங்கள் அனைத்து வெகுமதிகளையும் பெற்றுவிட்டீர்கள்",
          noRewardsClaimedTitle: "இப்பொழுது தங்களிடம் வெகுமதிகள் இல்லை",
          noRewardsClaimedText: "தயவு செய்து நாளை வரவும்",
          rewardHistoryFooterText: "வெகுமதிகள் மற்றும் பரிசுகள் விபரம்",
          headerText: "போர்ட்டர் ரிவாா்ட்ஸ் விழா"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "வெல்லுங்கள் ஒரு " + vehicleModel,
          headerDetails: "அதிக வெகுமதி புள்ளிகள் பெற்ற பார்ட்னர் இந்த உயர்ந்த புதிய டிரக்கை வெல்வார்",
          claimedText: "பெற்றுவிட்ட வெகுமதி",
          toClaimText: "உங்கள்  வெகுமதிகளை பெறுங்கள்",
          footerText: "அதிக அளவு  உங்களுக்கு முன்னேற்றத்தை கொடுக்கும்",
          milestone1: "ஸ்டார்",
          milestone2: "பிரான்ஸ் ஹீரோ",
          milestone3: "பிரான்ஸ் சூப்பர் ஸ்டார்",
          milestone4: "சில்வர் ஹீரோ",
          milestone5: "சில்வர் சூப்பர் ஸ்டார்",
          milestone6: "பிளாட்டினம் ஹீரோ",
          milestone7: "பிளாட்டினம் சூப்பர் ஸ்டார்",
          milestone8: "கோல்ட் ஹீரோ",
          milestone9: "கோல்ட் சூப்பர் ஸ்டார்",
          milestone10: "டைமண்ட் ஹீரோ",
          milestone11: "டைமண்ட் சூப்பர் ஸ்டார்",
          milestone12: "போர்ட்டர் ஹீரோ",
          milestone13: "சுப்ரோ சூப்பர் ஸ்டார்",
          locked: "அப்பார்பட்டது"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: " வாழ்த்துக்கள் ",
          winLabel: " நீங்கள் வெற்றி பெற்று விட்டீர்கள் ",
          winNotice: " பரிசை எவ்வாறு பெறுவது, குறித்து நாங்கள் உங்களுக்கு தொலைபேசி வாயிலாக அறிவிப்போம் ",
          lossNotice: " மன்னிக்கவும். இந்த முறை நீங்கள் எந்த பரிசையும் வெல்லவில்லை. பரிசை வெல்ல அடுத்த திட்டத்தில் சிறப்பாக பங்கேற்கவும்.",
          endTitle: " போர்ட்டர் பரிசு&வெகுமதி திட்டம்  முடிவடைந்தது ",
          endText: " அடுத்த திட்டம் விரைவில் அறிவிக்கப்படும் ",
          scoreTitle: " உங்களின் பங்களிப்பு எவ்வாறு இருந்தது என்று இங்கே காணுங்கள் ",
          totalScoreSubtext: " பெற்ற மொத்த புள்ளிகள்  ",
          customerExperienceScoreSubtext: " வாடிக்கையாளரின் அனுபவத்திற்காக ",
          orderCompletionScoreSubtext: " சவாரி முடித்ததற்காக ",
          loginActivityScoreSubtext: " லாகின் செய்ததற்காக ",
          topGiftsTitle: " சிறந்த வெகுமதிகளில் சில இங்கே ",
          topPartnersTitle: " எங்கள் சிறந்த ஓட்டுனர்களில் சிலர் இங்கே",
          partnerName: " ஓட்டுநரின் பெயர்",
          awardTitle: " வென்ற விருது "
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "வெகுமதி",
            yesterdayRowTitle: "நேற்று",
            rewardNavTabTitle: "தினசரி வெகுமதிகள்",
            awardNavTabTitle: "லெவெல் பரிசுகள்"
          },
          milestoneDetails: getMilestoneDetails("Mahindra"),
          customerServiceRewards: {
            text1: "நீங்கள் சம்பாதித்துள்ளது",
            text2: "வாடிக்கையாளரின் நல்ல அனுபவத்திற்கு"
          },
          loginActivtyRewards: {
            text1: "நீங்கள் சம்பாதித்துள்ளது",
            text2: "லாகின் நடவடிக்கை"
          },
          orderFulfillmentRewards: {
            text1: "நீங்கள் சம்பாதித்துள்ளது",
            text2: "ஏற்றுக் கொண்ட அனைத்து சவாரிகளை நிறைவேற்றியதற்காக"
          },
          mahindraAwards: {
            cardTitle: "வெல்லுங்கள் ஒரு மஹிந்திரா",
            cardText: "மேலும் தெரிந்து கொள்ள இங்கே தட்டவும்.",
            modalTitle: "வெல்லுங்கள் ஒரு மஹிந்திரா",
            modalText: "ஓவ்வொரு மாதமும் ஆச்சர்யமூட்டும் பரிசுகளை வெல்லுங்கள மற்றும் பிரம்மாண்ட  பரிசான மஹிந்திரா சுப்ரோவையும் வெல்லுங்கள். மேலும் தெரிந்து கொள்ள உங்கள் புள்ளிகளை தொடர்ந்து சரிபார்க்கவும்."
          },
          defaultLCVAward: {
            modalTitle: "இந்த தீபாவளியில் பம்பர் பரிசுகள் மற்றும் நிறைய பரிசுகளை வெல்லும் வாய்ப்பைப் பெறுங்கள்!",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "இந்த தீபாவளியில் பம்பர் பரிசுகள் மற்றும் நிறைய பரிசுகளை வெல்லும் வாய்ப்பைப் பெறுங்கள்!",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "ஒவ்வொரு வாரமும் அட்டகாசமான பரிசுகளை வெல்லுங்கள்.",
            modalText: ""
          },
          noAward: {
            cardTitle: "அடுத்த கட்ட பரிசை வெல்ல விரைவாக செயல்படுங்கள்",
            cardText: "நீங்கள் வென்ற பரிசை வேறு ஒரு பார்ட்னர் எடுத்துவிட்டார்.",
            modalTitle: "அடுத்த கட்ட பரிசை வெல்ல விரைவாக செயல்படுங்கள்",
            modalText: "நீங்கள் வென்ற பரிசை வேறு ஒரு பார்ட்னர் எடுத்துவிட்டார்.அடுத்த கட்ட பரிசை நீங்கள் வெல்ல விரைவாக செயல்படுங்கள்."
          },
          insuranceAward: {
            cardTitle: "வாகன இன்சூரன்ஸ்-ல் தள்ளுபடி பெற்றுள்ளீர்கள்",
            modalTitle: "வாழ்த்துக்கள்!வாகன இன்சூரன்ஸ்-ல் தள்ளுபடி பெற்றுள்ளீர்கள்"
          },
          distributionCeremonyAward: {
            cardTitle: "போர்ட்டரிடமிருந்து கவர்ச்சிகரமான பரிசுகளை வெல்வதற்கான வாய்ப்பை நீங்கள் பெறுகிறீர்கள்",
            cardText: "சிறந்த ஓட்டுனர்கள் கவர்ச்சிகரமான பரிசுகளை வெல்லும் வாய்ப்பை பெறுவார்கள். விதிமுறைகள் & நிபந்தனைகளுக்கு பொருந்தும்",
            modalTitle: "போர்ட்டரிடமிருந்து கவர்ச்சிகரமான பரிசுகளை வெல்வதற்கான வாய்ப்பை நீங்கள் பெறுகிறீர்கள்",
            modalText: "சிறந்த ஓட்டுனர்கள் கவர்ச்சிகரமான பரிசுகளை வெல்லும் வாய்ப்பை பெறுவார்கள்.விதிமுறைகள் & நிபந்தனைகளுக்கு பொருந்தும்"
          },
          finalAward: {
            cardTitle: "போர்ட்டரிடமிருந்து \"மஹிந்திரா சுப்ரோ\" வாகனத்தை வெல்வதற்கான வாய்ப்பை நீங்கள் பெறுகிறீர்கள்",
            cardText: "இந்திய அளவில் ஒரு தலைசிறந்த பார்ட்னர் வெல்வார்",
            modalTitle: "போர்ட்டரிடமிருந்து \"மஹிந்திரா சுப்ரோ\" வாகனத்தை வெல்வதற்கான வாய்ப்பை நீங்கள் பெறுகிறீர்கள்",
            modalText: "இந்திய அளவில் ஒரு தலைசிறந்த பார்ட்னர் வெல்வார்.வெற்றியாளர்கள் நிகிழ்ச்சியின் முடிவில் அறிவிக்கப்படுவார். விதிமுறைகள் மற்றும் நிபந்தனைகளுக்கு உட்பட்டது"
          },
          couponAward: {
            couponText: "கூப்பன்",
            redeemTitle: "எடுக்கும் வழிமுறைகள்.",
            detailsText: "விவரம்",
            tncText: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
            codeAckTitle: "கூப்பன் எண் பெறப்பட்டது."
          },
          status: {
            loading: "பதிவேற்றிக்கொண்டு இருக்கிறது",
            internetNotConnected: "இன்டர்நெட்  இணைக்கப்படவில்லை",
            tapToRetry: "மீண்டும் முயற்சிக்க அழுத்தவும்",
            ise: "பிழை ஏற்பட்டுள்ளது",
            loadingFailed: "பதிவேற்றம் நடக்க வில்லை"
          },
          category: {
            customerService: "வாடிக்கையாளர் சேவை",
            loginHours: "லாகின் நடவடிக்கை",
            orderFulfillment: "முடிந்த சவாரிகள்"
          },
          customerServiceDetails: {
            details1: "உங்கள் சவாரியில் 5 நட்சத்திர மதிப்பீடு பெற்றால் உங்கள் வாடிக்கையாளர் சேவை புள்ளிகள் அதிகரிக்கும்",
            details2: "அதனால்,தந்களது சவாரியில் 5 நட்சத்திர மதிப்பீடு பெறுங்கள்",
            sectionHeader: "5 நட்சத்திர மதிப்பீடுகள் எப்படி பெறுவது?",
            tip1: "எப்பொழுதும் வாடிக்கையாளரிடம் மரியாதையாகவும்,தன்மையாகவும்,பணிவுடனும் பேசுங்கள்.",
            tip2: "வாடிக்கையாளரிடம் ஒருபோதும் வாக்குவாதத்தில் ஈடுபடாதீர்கள். ஒரு வேளை பிரச்சனை இருந்தால் கால் சென்ட்டரிடம் தெரிவிக்கவும்.",
            tip3: "கவனமாக வாடிக்கையாளர் பொருட்களை கையாளுங்கள்."
          },
          loginHourDetails: {
            details1: "அதிக நேரம் ஆன்லைன்,தந்கள் லாகின் ஆக்டிவிடீ புள்ளிகள் அதிகரிக்கும்",
            tips: "குறிப்புகள்",
            tip: "சொந்த சவாரி இல்லாத நேரத்தில் அதிகமாக ஆன்லைனில் இருந்து நிறைய சம்பாதியுங்கள்"
          },
          orderFulfillmentDetails: {
            details1: "நிரைவேற்றிய சவாரிகளின் புள்ளிகள் எவ்வாறு பெறுவது ?",
            details2: "நிரைவேற்றக் கூடிய சவாரிகளை மட்டுமே ஒப்புக் கொள்ளவும். வாடிக்கையாளரிடம் சவாரி ரத்து செய்ய கூற வேண்டாம்.",
            tip1: "ஏற்றுக் கொண்ட பின் சவாரி மறுக்காதீர்",
            tip2: "வாடிக்கையாளரிடம் சவாரி ரத்து செய்ய கூற வேண்டாம்",
            slabTableText: "முடிந்த சவாரிகளுக்கான புள்ளிகளை கீழ்காணுங்கள்",
            slabTableCol1: "முடிந்த சவாரிகள்\"",
            slabTableCol2: "\"ுள்ளிகள்"
          },
          miscellaneous: {
            points: "புள்ளிகள்"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "காலாவதியாகும் தேதி " + date;
            }),
          getExpiringDateTitle: (function (date) {
              return "முடிவடையும் நாள் " + date;
            }),
          getExpiryHoursTitle: (function (hours) {
              return "காலாவதியாகும் நேரம் " + hours + " மணிநேரம்";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "நீங்கள் ஒரு " + currentMilestone + " ஸ்டார்";
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + nextMilestone + " ஆக மாற இன்னும் " + points + " புள்ளிகள் தேவைப்படுகிறது";
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " ஃப ஸ்டார் சவாரிகள்";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return " தாங்கள் நிறைவேற்றியது " + completedOrders + " சவாரிகள் ";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return "வெகுமதி பெற்ற லாகின் மணிநேரங்கள் " + loginHours;
            }),
          getLoginRewardsDetailsText: (function (points) {
              return " உங்களிடம் " + points + " லாகின் ஆக்டிவிடீ புள்ளிகள் உள்ளன ";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "தந்களிடம் " + points + " வாடிக்கையாளர் சேவை புள்ளிகள் உள்ளன";
            }),
          getNextMilestoneSubText: (function (points) {
              return "பெறவேண்டிய புள்ளிகள் " + points;
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return " ஓவ்வொரு 5  நட்சத்திர மதிப்பீட்டிற்கு " + points + "  புள்ளிகள் கிடைக்கும் ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return "தாங்கள் " + startTime + " இல் இருந்து " + endTime + " வரை  ஆந்‌லைந் செய்கையில் தந்கள் லாகின் ஆக்டிவிடீ புள்ளிகள் அதிகரிக்கும்  ";
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "" + startTime + " இல் இருந்து " + endTime + " வரை அதிக நேரம் ஆன்லைன் இருக்க முயற்சி செய்யுங்கள்";
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " ஒவ்வொரு மணிநேரமும்  லாகின்-இல் இருப்பது " + points + " புள்ளிகளுக்கு சமம். அதிக நேரம் அதிக புள்ளிகளுக்கு சமம்  ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return " தங்களிடம் " + points + " நிரைவேற்றிய சவாரிகளுக்கான புள்ளிகள் உள்ளன ";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return " ஒரு நாளில் " + points + " புள்ளிகளே பெற முடியும்";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " மேலும் " + points + "புள்ளிகள் தேவை ";
            }),
          getLastSlabText: (function (orders) {
              return "" + orders + " க்கு மேல் ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " நீங்கள் " + fuelQuantity + " லிட்டர் எரிபொருள் பரிசாக வென்றுள்ளீர்கள் ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " ரூ " + fuelMoney + " தங்கள் வாலட்டில் போடப்பட்டது.  ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " நீங்கள் " + fuelQuantity + " லிட்டர் எரிபொருள் பரிசாக வென்றுள்ளீர்கள் ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " ரூ " + fuelMoney + " க்கு சமமான தொகை தங்கள் வாலட்டில் போடப்பட்டது. ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " " + acceptAdvantage + " செகண்ட் தாமதம் இனி வரும் சவாரிகளில் இல்லை ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " " + endDate + " வரை " + acceptAdvantage + " செகண்ட் தாமதம் இனி வரும் சவாரிகளில் பெறமாடீர்கள்.";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " வாழ்த்துக்கள்! " + acceptAdvantage + " செகண்ட் தாமதம் இனி வரும் சவாரிகளில் இல்லை ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " போர்ட்டர் பிரீமியம் பார்ட்னர் விருதை வென்றுள்ளீர்கள். கீழே குறிப்பிடப்பட்டுள்ள தேதிகளில் இனி ஆர்டர்களில் " + acceptAdvantage + " வினாடிகள் தாமதத்தை எதிர்கொள்ள மாட்டீர்கள்.\n        தொடக்க தேதி - " + startDate + "\n        முடிவு தேதி - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " நீங்கள் ₹ " + amount + " -ஐ வென்றுள்ளீர்கள் ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " வென்றுள்ள ₹ " + amount + " உங்கள் வாலட்டில் சேர்க்கப்பட்டுள்ளது ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " வாழ்த்துக்கள்!! நீங்கள் ₹ " + amount + " -ஐ வென்றுள்ளீர்கள் ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " வென்றுள்ள ₹ " + amount + " உங்கள் வாலட்டில் சேர்க்கப்பட்டுள்ளது ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " போர்ட்டரிடம் இன்சூரன்ஸ்-ஐ ₹" + price + " பெற்றுக்கொள்ளலாம்!! இது " + endDate + " வரை செல்லுபடியாகும் ";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " போர்ட்டரிடம் இன்சூரன்ஸ்-ஐ ₹" + price + " பெற்றுக்கொள்ளலாம்!! இது " + endDate + " வரை செல்லுபடியாகும் ";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " போர்ட்டரிடம்  வாகன இன்சூரன்ஸில் ₹ " + discount + " தள்ளுபடியை வென்று உள்ளீர்கள்!! இது " + endDate + " வரை செல்லுபடியாகும் ";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " போர்ட்டரிடம்  வாகன இன்சூரன்ஸில் ₹ " + discount + " தள்ளுபடியை வென்று உள்ளீர்கள்!! இது " + endDate + " வரை செல்லுபடியாகும் ";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " நீங்கள் " + multiplier + " வெகுமதி புள்ளிகளை வெல்வீர்கள்";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " " + startDate + " முதல், எல்லா புள்ளி வகையிலும் " + multiplier + " வெகுமதி புள்ளிகள் கிடைக்கும்.இது " + endDate + " வரை செல்லுபடியாகும்";
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " வாழ்த்துக்கள்!நீங்கள் " + multiplier + " வெகுமதி புள்ளிகளை வெல்வீர்கள்";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " " + startDate + " முதல், எல்லா புள்ளி வகையிலும் " + multiplier + " வெகுமதி புள்ளிகள் கிடைக்கும்.இது " + endDate + " வரை செல்லுபடியாகும்";
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " பரிசு " + recipient_cnt + " ஓட்டுனருக்கு வழங்கப்பட்டது ";
            })
        };
}

var Tamil = {
  getContent: getContent
};

export {
  Tamil ,
  
}
/* No side effect */
